import { render, staticRenderFns } from "./SelectCarrierType.vue?vue&type=template&id=774f5a7b&scoped=true&"
import script from "./SelectCarrierType.vue?vue&type=script&lang=ts&"
export * from "./SelectCarrierType.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCarrierType.vue?vue&type=style&index=0&id=774f5a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f5a7b",
  null
  
)

/* custom blocks */
import block0 from "./SelectCarrierType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports